<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20.1956 8.18146C19.8694 7.1521 19.3429 6.19741 18.6463 5.37237C18.8114 6.14782 18.9492 6.94562 18.8367 7.73053C18.7243 8.51544 18.3236 9.29562 17.6338 9.68659C16.1791 10.5109 14.3848 9.49163 14.1242 9.33722C13.6423 9.05305 13.2252 8.67109 12.8998 8.21595C12.52 7.67213 12.3881 7.17457 12.2772 6.73828C12.0827 5.9592 12.0465 5.14904 12.1706 4.35571C12.2724 3.70172 12.4796 3.06859 12.7842 2.48097C12.448 2.59261 11.3425 2.99323 10.8042 3.81786C10.7015 3.98081 10.6096 4.15028 10.529 4.3252C10.3604 4.72415 10.2456 5.14376 10.1877 5.57299C10.0343 6.76262 10.4708 8.04846 10.5455 8.26284C9.58592 7.46552 8.89335 6.39357 8.5609 5.19106C8.43958 4.7151 8.41067 4.22028 8.47572 3.73343C8.65872 2.25837 9.61935 1.31792 9.97749 1C9.54295 1.07547 8.13987 1.37515 7.18541 2.59286C6.87401 2.99315 6.6372 3.44621 6.4863 3.93038C6.3698 4.31131 6.25679 4.88228 6.35604 5.80679C6.56955 7.79491 7.60638 9.9425 7.90438 10.5399C6.94799 10.0234 6.00107 9.40708 5.40905 8.49546C4.81703 7.58384 4.66386 6.31232 5.29822 5.42965C4.82327 5.71563 4.42297 6.11022 4.13019 6.581C3.38419 7.79292 3.66644 9.05771 3.72024 9.28012C3.94439 10.2064 4.49232 10.7676 5.41154 11.7091C5.8875 12.1979 6.40545 12.6439 6.95945 13.042L9.21705 14.666C9.42838 14.818 9.64936 14.9818 9.75178 15.2211C9.83042 15.4048 9.82924 15.6113 9.82681 15.8112L9.7534 21.7824C11.7484 22.1725 13.8106 22.0364 15.7371 21.3875C15.2302 19.2319 15.0239 17.5527 15.0058 16.618C14.9919 15.8983 15.0781 15.0575 15.6858 14.6715C15.8613 14.56 16.075 14.4919 16.1976 14.324C16.4184 14.022 16.2258 13.6033 16.2308 13.2292C16.237 12.7366 16.6078 12.3142 17.0345 12.0681C17.4613 11.822 17.9493 11.708 18.408 11.5285C19.3999 11.1405 20.3293 10.3031 20.375 9.23909C20.3903 8.87982 20.3039 8.52391 20.1956 8.18146Z"
            fill="url(#paint0_linear_5156_483)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5156_483"
                x1="11.9999"
                y1="22.0001"
                x2="11.9999"
                y2="1"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#3F414B" />
                <stop offset="1" stop-color="#6F727E" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
